import type { ReactNode } from "react";

import { Box, Button, Typography } from "@luce/ui";

interface InfoSectionProps {
  title: string;
  onViewAll?: () => void;
  children: ReactNode;
}

export function InfoSection({ title, onViewAll, children }: InfoSectionProps) {
  return (
    <Box className="gap-spacing-sm flex flex-col">
      <Box className="flex min-h-[40px] flex-row items-center justify-between">
        <Typography variant="body-md" color="neutral-foreground-default">
          {title}
        </Typography>
        {onViewAll ? (
          <Button variant="tertiary" size="sm" label="View All" onClick={onViewAll} />
        ) : null}
      </Box>
      {children}
    </Box>
  );
}
